import { BoostSolidIconDisplay } from 'src/components/SponsoredListings';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './CampaignModal.css';

export const CampaignModalIntroHeader = () => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      gap="l"
      width="full"
      className={styles.boostHeaderContainer}
    >
      <BoostSolidIconDisplay size="56px" />
      <span className={styles.boostHeaderText}>
        <Content id={ContentId.IntroducingBoost} />
      </span>
      <span className={styles.boostSubHeaderTextSmall}>
        <Content id={ContentId.BoostIntroMessage} />
      </span>
    </Stack>
  );
};
